import { Button } from '@brighterion/br-ui';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { ReportNoDataWarningModal } from './ReportNoDataWarningModal';

type Props = {
    extendedFormValues: NewMerchantReportFormValues | undefined;
    setGenerateReportBtnClicked: Dispatch<SetStateAction<boolean>>;
    currencyChange: boolean;
    disabled: boolean;
};

const GenerateReportButton = ({ extendedFormValues, currencyChange, setGenerateReportBtnClicked, disabled }: Props) => {
    const { t } = useTranslation();
    const [warningModalOpen, setWarningModalOpen] = useState(false);

    const validate = () => {
        const isOutOfMinRange = extendedFormValues?.dateRange?.isOutOfMinRange;
        if (isOutOfMinRange) {
            setWarningModalOpen(true);
        } else {
            setGenerateReportBtnClicked(true);
        }
    };

    return (
        <>
            <Button
                variant='contextual-secondary'
                size='small'
                data-testid='generate-new-report-btn'
                onClick={handleOnClickEvent(validate)}
                onKeyDown={handleKeyEvent(validate)}
                disabled={disabled}
            >
                {t('Generate New Report')}
            </Button>
            <ReportNoDataWarningModal
                isOpen={warningModalOpen}
                closeModal={() => {
                    setWarningModalOpen(false);
                }}
                currencyChange={currencyChange}
                dateRangeMinValue={extendedFormValues?.dateRange?.dateRangeMinValue || new Date()}
                generateReport={() => setGenerateReportBtnClicked(true)}
            />
        </>
    );
};

export default GenerateReportButton;
